// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1vL57","paramInput":"JobSimulator_paramInput__3E--M","input":"JobSimulator_input__5IcJC"};